import type { IGamePlayGroundProps } from '@/types/components'
import { packageNameKeyPosition } from '@/contants/old-game-position'
import type { IControlStateInfo, IPresetKeyboardMap } from '@/utils/cloud-device-sdk'

export function useCloudGameKeyBoardSet(detail: IGamePlayGroundProps) {
  // eslint-disable-next-line prefer-const
  let customSetButtonId = ''
  // eslint-disable-next-line prefer-const
  let currentStatusConfigKeyboardPosition = {}
  // eslint-disable-next-line prefer-const,unused-imports/no-unused-vars
  let updateSDKConfigKeyboardPosition = (newInfo: IControlStateInfo) => { }
  const isInEditPresetKeyboardStatus = ref(false)
  const isInTipsPresetKeyboardStatus = ref(false)
  const defaultConfigKeyboardPosition = detail.button || packageNameKeyPosition[detail.packageName as keyof typeof packageNameKeyPosition] || ({})
  const gameButtonMapPosition = ref(detail.button || packageNameKeyPosition[detail.packageName as keyof typeof packageNameKeyPosition] || ({}))

  function updateIsInEditPresetKeyboardStatus(salt: boolean) {
    isInEditPresetKeyboardStatus.value = salt
    isInTipsPresetKeyboardStatus.value = false
  }

  function toggleIsInTipsPresetKeyboardStatus() {
    isInTipsPresetKeyboardStatus.value = !isInTipsPresetKeyboardStatus.value
  }

  provide('custom-keyboard-data', {
    defaultConfigKeyboardPosition,
    customSetButtonId,
    isInEditPresetKeyboardStatus,
    isInTipsPresetKeyboardStatus,
    currentStatusConfigKeyboardPosition,
    updateIsInEditPresetKeyboardStatus,
    updateSDKConfigKeyboardPosition,
    toggleIsInTipsPresetKeyboardStatus,
  })

  return { gameButtonMapPosition, isInEditPresetKeyboardStatus, updateIsInEditPresetKeyboardStatus }
}
